import { useSelector } from 'react-redux'

import { getWodStrings } from 'store/strings/selectors'
import useWorkout from 'hooks/useWorkout'
import WorkoutOfTheDay from 'ui-component-library/components/DailyModule/WorkoutOfTheDay'

type Props = {
  isPreview: boolean
  date: Date
  fullPath: string
  commentLabelText: string
}

function DailyModuleWorkoutOfTheDayContainer({
  date,
  isPreview = false,
  fullPath,
  commentLabelText,
}: Props) {
  const { headlineText } = useSelector(getWodStrings)
  const { isLoading, workout, commentsUrl, commentsCount } = useWorkout({
    date,
    isPreview,
    fullPath,
  })

  return (
    <WorkoutOfTheDay
      commentLabelText={commentLabelText}
      headlineText={headlineText}
      isLoading={isLoading}
      commentsCount={commentsCount}
      commentsUrl={commentsUrl}
      htmlContent={workout ? workout.htmlContent : ''}
    />
  )
}

export default DailyModuleWorkoutOfTheDayContainer
